import request from "@/utils/request";

// export function getSearch() {
//     return request.post('/home/search')
// }


export function getSearch(search) {
    console.log(search,77);
    return request({
      url: "/home/search",
      method: 'post',
      data:{
        search
      }
    })
  }